
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 800 800"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Calque_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 800 800","style":"enable-background:new 0 0 800 800;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('p')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}})]),_c('g',[_c('path',{staticClass:"cls-2",attrs:{"d":"M264,475.4c0,10.4,0,19.9,0,30.4c2.5-1.1,4.6-3,6.4-2.8c4.3,0.4,10,0.5,12.2,3.2c2.2,2.6,2.7,9.4,0.8,12.3\n\t\tc-6.9,10.7-14.7,20.8-23,30.5c-2.2,2.5-8.9,4.5-11,3.1c-3.7-2.6-7.5-7.9-7.7-12.2c-0.9-17.7-2-35.6,0-53\n\t\tc2.9-24.6-4.9-42.4-25.3-56.5c-11.6-8-21.3-18.6-31.8-28.1c-12-10.9-10.2-18.9,5.5-23.8c133.2-41.6,266.4-83.1,399.6-124.6\n\t\tc5.4-1.7,10.7-3.5,16.1-5.3c6.3-2,12.2-2,15.7,4.6c3.3,6.3,0.6,11.2-4.5,15.7C567.1,313.7,517,358.6,467,403.5\n\t\tc-37.9,34-75.8,68.1-113.7,102.2c-18.3,16.4-35.1,16.4-53.7-0.2c-10.8-9.6-21.7-19.3-32.5-28.9C266.7,476.2,265.9,476.1,264,475.4z\n\t\t M272.1,451.3c13.8,12.5,26.2,23.6,38.5,34.7c14.8,13.4,16.9,13.4,31.7,0.1c61.3-55.1,122.5-110.2,183.9-165.3c2-1.7,4.6-2.7,7-4\n\t\tc-0.9-0.9-1.7-1.9-2.6-2.8C445,359.5,359.3,405,272.1,451.3z M209.8,395.2c13.4,12.1,25.4,22.4,36.8,33.5c5.7,5.5,10,6.4,17.3,2.4\n\t\tc73.8-39.5,147.8-78.6,221.7-117.9c2.7-1.4,5.2-3.2,7.8-4.8c-0.2-0.4-0.5-0.9-0.7-1.3C399.1,336.2,305.5,365.4,209.8,395.2z"}})])])
          )
        }
      }
    